import { useMemo } from 'react';

const FIELDS_NAMES = {
  CONTENT_TAGS: 'Content Tags',
};

const DEFAULT_SUPPLY_SOURCE_POD_DETAILS = [{ label: FIELDS_NAMES.CONTENT_TAGS, value: '-' }];

const podDetailsResolver = (data) => [
  {
    label: FIELDS_NAMES.CONTENT_TAGS,
    value: [
      ...new Set(
        data?.['pod-info']?.reduce((acc, pod) => {
          const isTagsValid = Array.isArray(pod?.['subject-tags']);
          return isTagsValid ? [...acc, ...pod?.['subject-tags']] : acc;
        }, [])
      ),
    ],
  },
];

const resolveSupplySourcePodDetailsResolver = (data) => {
  return data ? podDetailsResolver(data) : DEFAULT_SUPPLY_SOURCE_POD_DETAILS;
};

export const useSupplySourcePodDetailsResolverResolver = (data) => {
  return useMemo(() => resolveSupplySourcePodDetailsResolver(data), [data]);
};
